export default __webpack_public_path__ + "static/media/btn.80dea265.svg";